/* eslint-disable camelcase */
import { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { useLazyAuthInitTokenQuery } from 'modules/login/api'
import { setAuthInfo } from 'src/modules/login/helpers/token/token'

import { orderYarcheGuestRedirectCreateRoute } from '../routes/OrderYarcheGuestRedirectCreateRoute'
import { orderYarcheRedirectRoute } from '../routes/OrderYarcheRedirectRoute'

export const OrderYarcheRedirect = () => {
  const navigate = useNavigate()
  const { auth_code, state } = orderYarcheRedirectRoute.useSearch()
  const [authInitToken] = useLazyAuthInitTokenQuery()

  useEffect(() => {
    if (auth_code && state) {
      authInitToken({ code: auth_code, state }).then(({ data }) => {
        if (data) {
          setAuthInfo(data)
          localStorage.isLogged = true
          navigate(orderYarcheGuestRedirectCreateRoute)
        } else {
          navigate({ to: '/', replace: true })
        }
      })
    }
  }, [authInitToken, auth_code, navigate, state])

  return null
}
